import { CourseSingleUpdate, CourseFindById, CourseTerminalListByCourse } from './Request';

const mapCourse = (course, courseTerminals) => ({
  id: course.id,
  name: course.name,
  category: course?.CourseCategory?.id ?? '',
  description: course?.description ?? '',
  priority: course?.Priority?.id ?? '',
  expirationTime: course?.expirationTime ?? '',
  thumbnail: course?.thumbnail ?? '',
  terminals: courseTerminals,
});

export const updateCourse = async ({ id, isDraft }) => {
  const response = await CourseSingleUpdate({ id, isDraft });
  return response !== 0;
};

export const courseIsValid = async ({ id = '' }) => {
  const courseObject = await CourseFindById({
    id,
  });

  const courseTerminals = await CourseTerminalListByCourse({
    courseId: id,
  });

  const mappedObject = mapCourse(courseObject, courseTerminals);

  let isValid = false;

  if (
    mappedObject.name &&
    mappedObject.category !== '' &&
    mappedObject.priority !== '' &&
    mappedObject.expirationTime !== '' &&
    mappedObject.terminals.length > 0
  ) {
    isValid = true;
  }
  return { isValid };
};

export default { updateCourse, courseIsValid };
